require('./sendN2PasswordView.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @utils
const { formatText } = require('core/i18n').i18n;
const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');
const {
    getFullName,
    getFormattedShippingAddress,
    getFormattedShippingAddressExt
} = require('utilities/personalDataHelper');

// @ actions
const contractAddress = require('actions/contractAddress');
const profile = require('actions/profile');
const sendN2PasswordActions = require('actions/sendN2Password');

// @ commons
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');

// @ components
const SendN2PasswordStep1 = require('components/contactCenter/sendN2Password/sendN2PasswordStep1/sendN2PasswordStep1');
const SendN2PasswordSuccessStep = require('components/contactCenter/sendN2Password/sendN2PasswordSuccessStep/sendN2PasswordSuccessStep');
const SendN2PasswordErrorStep = require('components/contactCenter/sendN2Password/sendN2PasswordErrorStep/sendN2PasswordErrorStep');

// @ constants
const { CODE_ADDRESS_EXT } = require('constants/index');

class SendN2PasswordViewContainer extends React.Component {
    componentDidMount() {
        const { getContractAddress, requestProfile, history } = this.props;
        getContractAddress();
        requestProfile(history);
        this.handleEndInteraction = this.handleEndInteraction.bind(this);
    }

    handleEndInteraction() {
        const url = '/disasterRecovery/customerFinder';
        this.props.history.push(url);
    }

    buildEndInteractionBlock() {
        const textEndInteraction = formatText('addImposition-disasterRecoveryConfirmationBackbtn');
        return (
            <div className="customer-finder__end-interaction-block">
                <div className="customer-finder__end-interaction-button-container">
                    <div className="customer-finder__end-interaction-button">
                        <OKButton modifier="link-complementary" size="small" onClick={this.handleEndInteraction}>
                            <span className="customer-finder__end-interaction-link">{textEndInteraction}</span>
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    getContractAddressData() {
        const {
            immContractAddress
        } = this.props;
        let contractAddress = '';

        if (immContractAddress.get('fetchSuccess')) {
            if (immContractAddress.get('hasContractAddress')) {
                if (immContractAddress.get('codFormatoDomicilio') === CODE_ADDRESS_EXT) {
                    contractAddress = getFormattedShippingAddressExt(immContractAddress.get('contractAddressExt').toJS());
                } else {
                    contractAddress = getFormattedShippingAddress(immContractAddress.get('contractAddress').toJS());
                }
            } else contractAddress = '';
        } else if (immContractAddress.get('isFetching')) {
            contractAddress = (
                <div className="sendn2-cc-view__loading-section">
                    <LoadingSection />
                </div>
            );
        } else {
            contractAddress = '';
        }

        return contractAddress;
    }

    buildContent() {
        const { immProfileFields, postChange } = this.props;
        const contractAddress = this.getContractAddressData();
        const username = getFullName(immProfileFields);

        return (
            <div>
                <SendN2PasswordStep1
                    address={contractAddress}
                    onConfirm={postChange}
                    username={username}
                    immProfileFields={immProfileFields} />
                {isDisasterRecoveryMode() && this.buildEndInteractionBlock()}
            </div>
        );
    }

    buildSuccessful() {
        const { resetWizard } = this.props;
        return (
            <div className="row no-gutter">
                <div className="col-xs col-xs-12">
                    <SendN2PasswordSuccessStep onGoBack={resetWizard} />
                </div>
            </div>
        );
    }

    buildFailureView() {
        return (
            <div className="row no-gutter">
                <div className="col-xs col-xs-12">
                    <SendN2PasswordErrorStep />
                </div>
            </div>
        );
    }

    buildDisasterRecoveryContent(titleHeader, mappingBreadcrumb, content) {
        return (
            <div className="sendn2-cc-view sendn2-cc-view--disaster-recovery">
                <OKCover size="small" section="pg" extraClass="sendn2-cc-view__cover">
                    <OKHeaderLanding title="" />
                </OKCover>
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true} />
                <div className="sendn2-cc-view__body">
                    {content}
                </div>
            </div>
        );
    }

    render() {
        const { immProfileFields, immSendN2Data } = this.props;
        const titleHeader = formatText('profileKeysLanding-title');
        const submitSuccessful = immSendN2Data.get('submitSuccessful');
        const errorReceived = immSendN2Data.get('errorReceived');
        const mappingBreadcrumb = !__CONTACT_CENTER__ ? [
            ...(!__CONTACT_CENTER__ ? [
                {
                    text: titleHeader,
                    url: '/myprofile/keys'
                }
            ] : []),
            {
                text: formatText('profileKeysLanding-requestNewSignaturePost')
            }
        ] : []

        let content;
        if (submitSuccessful) {
            content = this.buildSuccessful();
        } else {
            if (!!errorReceived) {
                content = this.buildFailureView();
            }
            else {
                content = immProfileFields.get('isFetching') ? (<LoadingSection />) : this.buildContent();
            }
        }
        const disasterRecoveryContent = this.buildDisasterRecoveryContent(titleHeader, mappingBreadcrumb, content);

        return (
            isDisasterRecoveryMode() ? disasterRecoveryContent :
            <section>
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                    />
                <div>
                    {content}
                </div>
            </section>
        );
    }
}

SendN2PasswordViewContainer.propTypes = {
    immContractAddress: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immSendN2Data: PropTypes.object.isRequired,
    getContractAddress: PropTypes.func,
    postChange: PropTypes.func,
    requestProfile: PropTypes.func,
    resetWizard: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = SendN2PasswordViewContainer;
module.exports.SendN2PasswordViewContainer = withRouter(connect(
    state => ({
        immContractAddress: state.contractAddress,
        immProfileFields: state.profile,
        immSendN2Data: state.sendN2Password
    }), {
    getContractAddress: contractAddress.getContractAddress,
    requestProfile: profile.requestProfile,
    postChange: sendN2PasswordActions.postChange,
    resetWizard: sendN2PasswordActions.resetN2PasswordWizard
})(SendN2PasswordViewContainer));
